import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-searchable-select',
  standalone: true,
  imports: [FormsModule, NgSelectModule],
  templateUrl: './searchable-select.component.html',
  styleUrls: ['./searchable-select.component.less'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchableSelectComponent),
      multi: true,
    },
  ],
})
export class SearchableSelectComponent implements ControlValueAccessor {
  @Input() items: unknown[] = [];
  @Input() bindLabel = 'label';
  @Input() bindValue = '';
  @Input() placeholder = '';
  @Input() searchable = true;
  @Input() clearable = true;
  @Input() loading = false;
  @Input() loadingText = 'Loading...';
  @Input() notFoundText = 'No results found';
  @Input() trackByFn?: (item: unknown) => unknown;
  @Input() compareWith: (item: unknown, value: unknown) => boolean = (item, value) =>
    this.bindValue ? (item as Record<string, unknown> | null)?.[this.bindValue] === value : item === value;

  @Output() readonly selectionChange = new EventEmitter<unknown>();

  value: unknown = null;
  disabled = false;

  private onChange: (value: unknown) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: unknown): void {
    this.value = value;
  }

  registerOnChange(fn: (value: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(value: unknown): void {
    this.value = value;
    this.onChange(value);
    this.selectionChange.emit(value);
  }

  onBlur(): void {
    this.onTouched();
  }
}
